import React from "react";

export const PriceWithUnit = ({ price, unit, prefix = "", className = "" }) => {
  const hasUnit = typeof unit === "string" && unit.trim().length > 0;

  return (
    <span className={className}>
      <span>
        {prefix}₹ {Number(price || 0).toLocaleString()}
      </span>
      {hasUnit ? (
        <span className="ml-1 align-middle text-[0.68em] font-medium opacity-70">
          / {unit.trim()}
        </span>
      ) : null}
    </span>
  );
};
